import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11.25 19.57v-7.14L5 8.813v7.138l6.25 3.62Zm1.5 0L19 15.95V8.812l-6.25 3.619v7.138ZM12 11.138l6.175-3.57L12 4 5.825 7.57zm-8.5 5.698V7.163L12 2.277l8.5 4.886v9.674L12 21.723l-8.5-4.886Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }